import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function EditorialPostCard({
  variant = 'media',
  feature = false,
  typeLabel,
  mediaUrl,
  meta,
  title,
  excerpt,
  footer,
  topRight,
  children,
  className = '',
  onClick,
}) {
  const classes = [
    'ed-post-card',
    `ed-post-card--${variant}`,
    feature ? 'ed-post-card--feature' : '',
    className,
  ].filter(Boolean).join(' ');

  const Tag = onClick ? 'button' : 'article';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={classes}
      onClick={onClick}
    >
      {topRight ? <div className="ed-post-card__top-right">{topRight}</div> : null}
      {variant !== 'text' ? (
        <div
          className="ed-post-card__media"
          style={mediaUrl ? { backgroundImage: `url(${mediaUrl})` } : undefined}
        >
          {typeLabel ? <span className="ed-post-card__type">{typeLabel}</span> : null}
        </div>
      ) : null}
      <div className="ed-post-card__body">
        {meta ? <div className="ed-post-card__meta">{meta}</div> : null}
        {title ? <h3 className="ed-post-card__title">{title}</h3> : null}
        {excerpt ? <p className="ed-post-card__excerpt">{excerpt}</p> : null}
        {children}
        {footer ? <footer className="ed-post-card__foot">{footer}</footer> : null}
      </div>
    </Tag>
  );
}

EditorialPostCard.propTypes = {
  variant: PropTypes.oneOf(['media', 'text']),
  feature: PropTypes.bool,
  typeLabel: PropTypes.node,
  mediaUrl: PropTypes.string,
  meta: PropTypes.node,
  title: PropTypes.node,
  excerpt: PropTypes.node,
  footer: PropTypes.node,
  topRight: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
